<template>
  <div id="template">
    <aside class="aside">
      <app-sidebar-header class="sidebar-header"></app-sidebar-header>
      <div class="sidebar">
        <ul class="list-unstyled" v-bind:class="[isActive ? 'up' : 'down']">
          <li><a href="https://diu.ac/" target="_blank" id="">DIU Home</a></li>
          <li>
            <router-link class="text-white"  to="/">Home {{  }}</router-link>
          </li>
          <li>

            <a href="#PersonalInformation" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#PersonalInformation` ? 'is-active' : ''">Personal Information</a>

          </li>
          <li v-if="results.academic_qualifications.length">

            <a href="#AcademicQualification" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#AcademicQualification` ? 'is-active' : ''">Academic Qualification</a>

          </li>
          <li v-if="results.training_experience.length">

            <a href="#TrainingExperience" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#TrainingExperience` ? 'is-active' : ''">Training Experience</a>

          </li>
          <li v-if="results.area_of_skills.length">

            <a href="#TeachingArea" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#TeachingArea` ? 'is-active' : ''">Teaching Area</a>

          </li>
          <li v-if="results.publications.length">

            <a href="#Publication" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#Publication` ? 'is-active' : ''">Publication</a>

          </li>
          <li v-if="results.awards.length">
            <a href="#AwardScholarship" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#AwardScholarship` ? 'is-active' : ''">Award & Scholarship</a>
          </li>
          <li v-if="results.memberships.length">
            <a href="#Membership" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#Membership` ? 'is-active' : ''">Membership</a>
          </li>
          <li v-if="results.employment.length">
            <a href="#PreviousEmployment" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#PreviousEmployment` ? 'is-active' : ''">Previous Employment</a>
          </li>
          <li v-if="results.expart_on.length">
            <a href="#ExpartOn" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#ExpartOn` ? 'is-active' : ''">Expert On</a>
          </li>
          <li v-if="results.counseling_hour.length">
            <a href="#CounsellingHour" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#CounsellingHour` ? 'is-active' : ''">Counselling Hour</a>
          </li>
          <li v-if="results.relGallery.length">
            <a href="#Gallery" :class="`${this.$route.fullPath}` == `/${$route.params.slug}#Gallery` ? 'is-active' : ''">Gallery</a>
          </li>
        </ul>
        <a class="toggle_drawer" href="javaScript:void(0);" @click="toggleClass()">
          <span>Menus</span>
          <i class="fas " v-bind:class="[isActive ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
        </a>
      </div>
      <app-sidebar-footer class="sidebar-footer"></app-sidebar-footer>
    </aside>
    <section class="entry">
      <article class="basic" id="PersonalInformation">
        <div class=""></div>
        <div class="content">
          <div class="profile-photo">
            <!--            <img class="mx-auto d-block" v-bind:src="'//api.diu.ac/' + results.profile_photo_file" :alt="results.name">-->

            <v-lazy-image class="mx-auto d-block"
                          :src="'//api.diu.ac/' + results.profile_photo_file"
                          :alt="results.name"
            />
          </div>
          <!-- <h2 class="">Hello I'm</h2> -->
          <h1 class="">{{ results.name }}</h1>
          <!-- <h3>{{ results.designation }}</h3> -->
          <h4 class="vc-desc">BScEngg Electrical (BUET), MScEnggElectrical (BUET), PhD (Cambridge) CEng(UK), FIET(UK), FIEB FBCS SrMIEEE(USA)</h4>
          <!-- <p>{{ results.overview }}</p> -->
              <p class="vc-overview ">
               Prof. Dr. Saiful Islam is currently the Vice-Chancellor of Dhaka International University (DIU) since 7 February 2022. During 22 June 2016 to 25 June 2020, Prof. Dr. Saiful Islam worked as the Vice-Chancellor of Bangladesh University of Engineering and Technology (BUET) for the full term of 4 years. During 26 August 2013 - 22 June 2016, he worked as the Pro-Vice Chancellor of Primeasia University, Banani, Dhaka, Bangladesh for a period of 2 years 9 months after being appointed by the Honorable President of Bangladesh and on leave from BUET. 
          </p>
            <p class="vc-overview">
                  Prof. Islam obtained his BScEng in Electrical Engineering degree from BUET in 1975, obtained First Class with Honours marks and stood First in order of merit. He obtained MScEng in EE in 1977 from BUET and PhD in EE from Cambridge University, UK in 1986. With a strong academic background, Prof. Islam started his career as a Lecturer of Electrical Engineering in BUET in 1975 and became Professor of Electrical & Electronic Engineering department in 1988.                
            </p>

             <p class="vc-overview">
                  Professor Saiful Islam is a <strong>Life Fellow </strong> of the Institution of Engineers Bangladesh (IEB), a <strong>Life Fellow </strong>of Bangladesh Computer Society, a Fellow of the Institution of Engineering & Technology (IET) UK, a <strong>Chartered Engineer (CEng) </strong>of the Engineering Council, UK. </p>

             <p class="vc-overview">
                   He is a <strong>Fellow</strong> of Cambridge Commonwealth Society, Cambridge, UK, a <strong>Senior Member</strong> of IEEE <strong>SrMIEEE (USA)</strong> . He is a former <strong>Vice President </strong> of Bangladesh Electronics Society. Professor Islam is a <strong>Life member </strong> of Caius Club of Gonville & Caius College, Cambridge University, Cambridge, UK.  </p>

             <p class="vc-overview">
                 During 1991-93, Professor Saiful Islam was the <strong>Head</strong> of the Electrical and Electronic Engineering Department of BUET and during 1995-97 he was the <strong>Dean</strong> of the Electrical and Electronic Engineering Faculty. During this period he also worked twice as the <strong>Chairman</strong> of the Admission Committee for two consecutive years. He was also the <strong>Head </strong> of the Computer Science and Engineering Department of BUET during 1996.</p>

             <p class="vc-overview">
                  During 1991, Professor Islam was with the Electrical and Computer Engineering Department of Kanazawa University, Kanazawa, Japan with the status of a <strong>Visiting Professor</strong>  and as a Matsumae International Foundation Fellow for a period of 3 months. During 1999-2000, he was a <strong>Visiting Professor</strong>  of Islamic Institute of Technology (now IUT), Gazipur for one year (on sabbatical leave from BUET). During 2002-2006 he was the first Dean of Engineering Faculty of American International University- Bangladesh (AIUB), Banani, Dhaka and put significant contribution in building the Engineering Faculty. He has shown significant success in building and help growing private Universities. Thus, he has developed significant skill in academic administration and management in both public and private Universities.</p>

             <p class="vc-overview">
                   During his illustrious service career he has earned significant reputation and professional excellence in his tenure of service spanning over 46 years in teaching, research and academic administration.  </p>

             <p class="vc-overview">
                   An eminent educationist, Prof.  Islam has been involved in a large number of National Engineering Projects and has left significant contribution in National level Engineering and Educational fields. He is well known for his innovative nature, unsurpassable quality in dynamic leadership and exceptional managerial capability.  </p>

             <p class="vc-overview">
                  He has been involved in research in Microwave coupled line devices, Semiconductor MQW Lasers, DFB Lasers, VCSELs, OPVCSELs. He has a large number of research papers in these areas in reputed journals. His professional experience covered a broad spectrum of areas like Microwave & RF Engineering, Satellite Communications, designing distribution systems for buildings and cities, special lighting for stadiums, exterior lighting of buildings, computer controlled exterior lighting. In recent years, he got involved in research on electrical energy, electrical power generation and planning. His expertise in the fields of Microwave & RF Engineering, RADAR, Satellite
                   Communications, Lasers, designing electrical distribution systems for buildings and cities, special lighting is well known.  Further information:   <a href="https://sislamk.tripod.com/">https://sislamk.tripod.com</a> <a class="ml-2" href="https://sislamk0.wixsite.com/ saifulislameee ">https://sislamk0.wixsite.com/ saifulislameee </a></p>

       
        </div>
       
      </article>
      <article class="contact">
        <h3>Contact Information</h3>
        <div class="row">
          <div class="col-md-12">
            <p><span>Address:</span> {{ results.department }}, {{  results.office_address }}</p>
          </div>
          <div class="col-md-4">
            <p><span>Phone:</span>
              <a :href="`tel:${results.personal_phone_no}`">{{ results.personal_phone_no }}</a>
            </p>
          </div>
          <div class="col-md-4">
            <p><span>Email:</span> <a :href="`mailto:${results.office_email}`">{{ results.office_email }}</a></p>
          </div>
          <div class="col-md-4">
            <p><span>Campus:</span> {{ results.campus }}</p>
          </div>
        </div>
        <div class="socials" v-if="results.socials.length">
          <p><span>Social Contacts:</span></p>
          <ul class="list-inline">
            <li class="list-inline-item" v-for="social in results.socials">

              <!--                                          {{ social }}-->

              <template v-if="social.name == 'WhatsApp'">
                <a
                  :href="`https://api.whatsapp.com/send/?phone=${social.url}&text=Hello+Sir.++I+need+help.&app_absent=0`"
                  target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else-if="social.name == 'Skype'">
                <a :href="`skype:live:${social.url}?chat`" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else-if="social.name == 'WeChat'">
                <a :href="`weixin://weixin.qq.com/r/${social.url}`" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else-if="social.name == 'Viber'">
                <a :href="`viber://contact?number=${social.url}`" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>

              <template v-else>
                <a :href="social.url" target="_blank">
                  <i :class="social.icon">&nbsp;</i>{{ social.name }}
                </a>
              </template>


            </li>
          </ul>
        </div>
      </article>
      <article class="accademic" id="AcademicQualification" v-if="results.academic_qualifications.length">
        <h3>Academic Qualifications</h3>
        <div class="row">
          <div v-for="qualification in results.academic_qualifications" class="col-md-6">
            <div class="content">
              <p>{{ qualification.title }} <span v-if="qualification.major">(Major in {{ qualification.major }})</span>
              </p>
              <p>{{ qualification.institute }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="experience" id="TrainingExperience" v-if="results.training_experience.length">
        <h3>Training Experience</h3>
        <div v-for="experience in results.training_experience" class="content">
          <p>{{ experience.title }} ({{ experience.institute }}) </p>
        </div>
      </article>
      <article class="teaching-area" id="TeachingArea" v-if="results.area_of_skills.length">
        <h3>Teaching Area</h3>
        <div class="row">
          <div v-for="skill in results.area_of_skills" class="col-md-6">
            <div class="content">
              <p>{{ skill.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="publication" id="Publication" v-if="results.publications.length">
        <h3>Publication</h3>
        <div v-for="publication in results.publications" class="content">
          <p><span>{{ publication.type }}</span></p>
          <p>{{  decodeURI(publication.description)  }}</p>
        </div>
      </article>
      <article class="award" id="AwardScholarship" v-if="results.awards.length">
        <h3>Award & Scholarship</h3>
        <div class="row">
          <div v-for="award in results.awards" class="col-md-6">
            <div class="content">
              <p>{{ award.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="membership" id="Membership" v-if="results.memberships.length">
        <h3>Membership</h3>
        <div class="row">
          <div v-for="membership in results.memberships" class="col-md-6">
            <div class="content">
              <p>{{ membership.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="employment" id="PreviousEmployment" v-if="results.employment.length">
        <h3>Previous Employment</h3>
        <div v-for="employment in results.employment" class="content">
          <p>{{ employment.position }} ({{ employment.institute }}) </p>
          <p>
            {{ employment.from }} -
            <!--                      {{ (employment.to == ' ') ? employment.to : 'Continue'  }}-->
            <span style="color: #333" v-if="employment.to">{{ employment.to }}</span>
            <span style="color: #333" v-else>Continue</span>

          </p>

        </div>
      </article>
      <article class="expart-on" id="ExpartOn" v-if="results.expart_on.length">
        <h3>Expert On</h3>
        <div class="row">
          <div v-for="expart_on in results.expart_on" class="col-md-6">
            <div class="content">
              <p>{{ expart_on.title }}</p>
            </div>
          </div>
        </div>
      </article>
      <article class="employment" id="CounsellingHour" v-if="results.counseling_hour.length">
        <h3>Counselling Hour</h3>
        <div v-for="counseling_hour in results.counseling_hour" class="content">
          <p>{{ counseling_hour.day }} - {{ counseling_hour.time_from }} to {{ counseling_hour.time_to }}</p>
          <p>{{ counseling_hour.place }}</p>
        </div>
      </article>

      <article v-if="results.relGallery.length" class="gallery" id="Gallery">
        <h3>Gallery</h3>
        <div class="card-columns">
          <div v-for="(row,index) in results.relGallery" :key="index">

            <div class="card">
              <!--              <img class="card-img-top" src="https://api.diu.ac/images/profile/gallery/1627643567_l9p0qkf92J.jpg"
                                 alt="Card image cap">-->

              <v-lazy-image class="card-img-top"
                            :src="`${row.img_file}`"
                            :alt="row.title"/>

              <div class="card-body">
                <h5 class="card-title">{{ row.title }}</h5>
                <!--                <p class="card-text">Some quick example</p>-->
              </div>
            </div>
          </div>
        </div>
      </article>
      <app-footer class="footer"></app-footer>
    </section>
  </div>
</template>

<script>
import SidebarHeader from './components/SidebarHeader.vue';
import SidebarFooter from './components/SidebarFooter.vue';
import Footer from './components/Footer.vue';
import {socialIcons} from './functions.js';
import VLazyImage from "v-lazy-image";

export default {
  components: {
    'app-footer': Footer,
    'app-sidebar-header': SidebarHeader,
    'app-sidebar-footer': SidebarFooter,
    'v-lazy-image': VLazyImage,
  },
  data() {
    return {
      results: [],
      isActive: false,
      aws_url: 'https://api.diu.ac/',
    }
  },
  name: 'App',
  metaInfo() {
    return {
      meta: [
        {property: 'og:image', content: this.aws_url + this.results.profile_photo_file}
      ]
    }
  },

  mounted() {

    var current = this;
    var slug = current.$route.params.slug;

    axios.get('https://api.diu.ac/public/profile/professorsaifulislam#PersonalInformation')
      .then(function (response) {
        current.results = response.data.data;
        current.results.socials.map((social, key) => {
          current.results.socials[key].icon = socialIcons[social.name]
        });

        // console.log(current.results.socials);

        //
      })
      .catch(function (error) {

      })
      .finally(function () {

      });
  },

  methods: {
    toggleClass(event) {

      if (this.isActive) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    }
  },
}
</script>

<style scoped>
.v-lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
}

.v-lazy-image-loaded {
  filter: blur(0);
}
.vc-overview{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    text-align: left;
    margin-bottom: 10px;
}
.vc-desc{
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;   
}
</style>



// WEBPACK FOOTER //
// src/Vcprofile.vue